import React, { useEffect, useState } from 'react';
import { Form, Button, Card, Alert, Container, Spinner } from 'react-bootstrap';
import { fetchPortById, updatePort } from './services/api';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

const PortEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navLocation = useLocation();
  const portFromState = navLocation.state?.port;
  const [name, setName] = useState('');
  const [location, setLocation] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (portFromState) {
      setName(portFromState.name);
      setLocation(portFromState.location);
      setLoading(false);
    } else if (id) {
      setLoading(true);
      fetchPortById(Number(id))
        .then(port => {
          setName(port.name);
          setLocation(port.location);
        })
        .catch(() => setError('Failed to fetch port'))
        .finally(() => setLoading(false));
    }
  }, [id, portFromState]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    setSuccess(false);
    try {
      await updatePort(Number(id), { name, location });
      setSuccess(true);
      setTimeout(() => navigate('/ports'), 1200);
    } catch (err) {
      setError('Failed to update port');
    }
    setSaving(false);
  };

  if (loading) return <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}><Spinner animation="border" /></div>;

  return (
    <Container className="p-4 p-md-5" style={{ maxWidth: 500 }}>
      <Card className="shadow-lg mt-4">
        <Card.Body>
          <h2 className="mb-4">Edit Location</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" value={name} onChange={e => setName(e.target.value)} required />
            </Form.Group>
            <Form.Group className="mb-3" controlId="location">
              <Form.Label>State</Form.Label>
              <Form.Control type="text" value={location} onChange={e => setLocation(e.target.value)} required />
            </Form.Group>
            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success">Location updated successfully!</Alert>}
            <div className="d-flex justify-content-between">
              <Button variant="secondary" onClick={() => navigate('/ports')} disabled={saving}>Back to List</Button>
              <Button variant="primary" type="submit" disabled={saving}>{saving ? 'Saving...' : 'Update Location'}</Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default PortEdit; 